// extracted by mini-css-extract-plugin
export default {"container":"Section_container__Ezv7a","hidden":"Section_hidden__D3TlL"};